import {
    CIRCLE,
    OVAL,
    SIZESMALL,
    SIZEMEDIUM,
    SIZEBIG,
    SpotlightVariantOptions,
    SpotlightShapeOptions,
    SpotlightVibrantOptions
} from '../components/wraps/spotlight/Spotlight.wrap';
import {AccentColorOptions} from 'epic-ue-theme';
import {ImageProps} from '../components/elements/images/Image';

// Custom spotlight gradients based on accent color
const FORESTGRADIENT = {from: '#23FC38', to: '#35D2B6'};
const SKYGRADIENT = {from: '#4BE6FB', to: '#759BFD'};
const GALAXYGRADIENT = {from: '#B959F3', to: '#3676B0'};
const FIREGRADIENT = {from: '#F50614', to: '#971A8A'};
const ORCHIDGRADIENT = {from: '#f43c9c', to: '#d01073'};
const WHITEGRADIENT = {from: '#fff', to: '#fff'};
const BLACKGRADIENT = {from: '#000', to: '#000'};
const NEONGRADIENT = {from: '#65de8a', to: '#24975d'};

export function setSize(
    variant: SpotlightVariantOptions,
    shape: SpotlightShapeOptions,
    dimension: string,
    width?: number,
    height?: number
): string {
    if (dimension === 'width' && width) {
        return `${width}px`;
    }

    if (dimension === 'height' && height) {
        return `${height}px`;
    }

    if (shape === CIRCLE) {
        switch (variant) {
            case SIZESMALL:
                return '400px';
            case SIZEMEDIUM:
                return '600px';
            case SIZEBIG:
                return '900px';
            default:
                return '600px';
        }
    } else if (shape === OVAL) {
        switch (variant) {
            case SIZESMALL:
                if (dimension === 'width') {
                    return '900px';
                }
                return '500px';
            case SIZEBIG:
                if (dimension === 'width') {
                    return '1250px';
                }
                return '450px';
            default:
                if (dimension === 'width') {
                    return '1250px';
                }
                return '450px';
        }
    }

    return '400px';
}

export function setOffset(
    innerDimension: number,
    offsetRatio: number[],
    orientation: string
): string {
    let offset = 0;
    if (offsetRatio && offsetRatio.length) {
        if (orientation === 'x') {
            offset = offsetRatio[0];
        } else if (orientation === 'y') {
            offset = offsetRatio[1];
        }
        if (innerDimension) {
            if (offset === 1) {
                return `${innerDimension}px`;
            } else {
                return `${offset * innerDimension + 100}px`;
            }
        }
    }
    return '0px';
}

export function getGradient(accentColor: AccentColorOptions): SpotlightVibrantOptions {
    switch (accentColor) {
        case 'forest':
            return FORESTGRADIENT;
        case 'sky':
            return SKYGRADIENT;
        case 'galaxy':
            return GALAXYGRADIENT;
        case 'fire':
            return FIREGRADIENT;
        case 'orchid':
            return ORCHIDGRADIENT;
        case 'white':
            return WHITEGRADIENT;
        case 'black':
            return BLACKGRADIENT;
        case 'neon':
            return NEONGRADIENT;
        default:
            return SKYGRADIENT;
    }
}

export function setGradient(
    accentGradient: SpotlightVibrantOptions,
    vibrantColor: SpotlightVibrantOptions,
    image?: string | ImageProps,
    showImage?: boolean
): string {
    let from = '';
    let to = '';

    if (showImage) {
        return `url(${image})`;
    }

    if (
        vibrantColor &&
        vibrantColor.from &&
        vibrantColor.from !== '' &&
        vibrantColor.to &&
        vibrantColor.to !== ''
    ) {
        from = vibrantColor.from;
        to = vibrantColor.to;
    } else if (
        accentGradient &&
        accentGradient.from &&
        accentGradient.from !== '' &&
        accentGradient.to &&
        accentGradient.to !== ''
    ) {
        from = accentGradient.from;
        to = accentGradient.to;
    }
    return `linear-gradient(135deg, ${from} 15%, ${to} 85%)`;
}
